module.exports = __webpack_public_path__ + "6af90213e4aa61137accefd46956c8fe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-28.png
// module id = 1643
// module chunks = 0